import React, {Component} from "react";
import axios from "axios";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import AnchorLink from 'react-anchor-link-smooth-scroll';
import {apiUrl} from '../../shared/config';
import Pattern from '../Pattern/Pattern';
import './PatternList.css';
import PaginationWidget from "../UI/PaginationWidget/PaginationWidget";
import classes from "../Pattern/Pattern.module.css";

class PatternList extends Component {

    state = {
        count: 0,
        authenticated: false,
        patterns: []
    };

    componentDidMount() {
        const url = apiUrl+'PatternList/getList';
        this.setState({authenticated: this.props.isAuthenticated});
        const quantity = (this.props.isAuthenticated ? this.props.patternList.quantity : this.props.patternList.quantity + 1);
        const params = {
            params: {
                quantity: quantity,
                offset: this.props.patternList.offset,
                keyword_ids_array: this.props.keywordsFilter,
                condition_ids_array: this.props.conditionsFilter,
                constraint_ids_array: this.props.constraintsFilter,
                consequence_ids_array: this.props.consequencesFilter,
                author_ids_array: this.props.authorsFilter,
                group_ids_array: this.props.groupsFilter,
                pattern_name_filter: this.props.patternNameFilter,
                pattern_problem_filter: this.props.designProblemFilter,
                game_ids_array: this.props.exampleGamesFilter,
                order_by: this.props.order_by,
                token: this.props.token
            }
        };
        axios.get(url, params)
            .then(response => {
                this.setState({patterns: response.data.patterns_array});
                this.setState({count: response.data.pattern_count});
                this.props.updateCount(response.data.pattern_count, null);
                this.setState({authenticated: this.props.isAuthenticated});
            }).then(
            this.props.listReloaded()
        );
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(
            this.props.reloadList === true ||
            prevProps.patternList.offset !== this.props.patternList.offset ||
            prevProps.order_by !== this.props.order_by ||
            this.props.isAuthenticated !== this.state.authenticated
        ) {
            const url = apiUrl +'PatternList/getList';
            this.setState({authenticated: this.props.isAuthenticated});
            const quantity = (this.props.isAuthenticated ? this.props.patternList.quantity : this.props.patternList.quantity + 1);
            const params = {
                params: {
                    quantity: quantity,
                    offset: this.props.patternList.offset,
                    keyword_ids_array: this.props.keywordsFilter,
                    condition_ids_array: this.props.conditionsFilter,
                    constraint_ids_array: this.props.constraintsFilter,
                    consequence_ids_array: this.props.consequencesFilter,
                    author_ids_array: this.props.authorsFilter,
                    group_ids_array: this.props.groupsFilter,
                    pattern_name_filter: this.props.patternNameFilter,
                    pattern_description_filter: this.props.descriptionFilter,
                    game_ids_array: this.props.exampleGamesFilter,
                    pattern_problem_filter: this.props.designProblemFilter,
                    order_by: this.props.order_by,
                    token: this.props.token
                }
            };
            // console.log('PARAMS: ', params);
            axios.get(url, params)
                .then(response => {
                    this.setState({patterns: response.data.patterns_array});
                    this.setState({count: response.data.pattern_count});
                    this.props.updateCount(response.data.pattern_count, null);
                })
                .then(
                    this.props.listReloaded()
                );
        }
    }



    render () {


        let newPatternSlug = (
            <Col className="pattern-list-col" key="0">
                <Pattern
                    selected=" new-pattern-list"
                    key="0"
                    name="Add a Pattern"
                    cardBodyText="Open the New Pattern panel to add a pattern."
                    cardBodyStyle=""
                    clicked={() => {
                        this.props.newPattern(null);
                        this.props.closePatternDetails();
                        this.props.patternSelected(null);
                    }}
                />
            </Col>
        );

        newPatternSlug = (this.props.isAuthenticated && this.props.userId > 0 ? newPatternSlug : '');
        const quantity = (this.props.isAuthenticated ? this.props.patternList.quantity : this.props.patternList.quantity + 1);
        let patterns = [];
        if(this.state.patterns) {
            patterns = this.state.patterns.map(pattern => {
                let isSelected = '';
                if(this.props.selectedPatternId === pattern.pattern_id) {
                    isSelected = ' selected';
                }

                return (
                    <Col className="pattern-list-col" key={pattern.pattern_id}>
                        {/*Removing this anchor link might have fixed the occasional 2 jump scroll we have been experiencing*/}
                        {/*<AnchorLink className="no-link-style" offset='80' href='#pattern-details'>*/}
                        <Pattern
                            chosenPattern={+pattern.pattern_id === +this.props.selectedPatternId}
                            selected={isSelected}
                            key={pattern.pattern_id}
                            name={pattern.pattern_name}
                            hiddenContent={pattern.hidden_content}
                            cardBodyText={pattern.pattern_descriptive_title !== '' ? pattern.pattern_descriptive_title : pattern.pattern_design_problem}
                            cardBodyStyle={pattern.pattern_descriptive_title !== '' ? "descriptive-title-card-text" + classes.truncate : "cardText "+ classes.truncate}
                            clicked={() => {
                                this.props.patternSelected(pattern.pattern_id);
                            }}
                            mergedStatus={+pattern.merged}
                        />
                        {/*</AnchorLink>*/}
                    </Col>
                )
            });
        }


        return (
            <div className="d-flex pattern-list-wrapper">
                <div className="pattern-list">
                    <Container fluid className="pattern-list-container" >
                        <Row xs={1} md={2} lg={2} xl={3} >
                            {newPatternSlug}
                            {patterns}
                        </Row>
                        <Row className="pattern-list-pagination">
                            <PaginationWidget
                                className="col-sm-6 align-self-center"
                                updatePage={this.props.updatePage}
                                count={this.state.count}
                                quantity={quantity}
                                offset={this.props.patternList.offset}
                            />
                        </Row>
                    </Container>
                </div>
            </div>
        );
    }
}

export default PatternList;
